import { NameDto } from '@/api/Common/Types'

import { BonusLabel } from '../../Wallet/Types/BonusCampaignTypes'

export interface BonusTransactionDto {
  id: string
  state: NameDto
  referenceId: string
  walletTransactionId: string
  bonusTransactionStatus: {
    id: number
    name: string
  }
  client: {
    tickmillCompany: NameDto<1 | 2 | 3 | 4 | 5>
    id: string
    name: string
  }
  wallet: {
    currency: NameDto<string>
    id: string
    name: string
  }
  createdDate: string
  updatedDate: string
  amount: number
  bonusReserved: number
  lotsRequired: number
  expiryDate: string
  bonusType: BonusType
  linkedDeposits?: LinkedDeposit[]
  bonusLabel: BonusLabel
  tradingAccount?: {
    id: string
    login: string
  }
  comment?: string
}

export interface LinkedDeposit {
  transactionId: string
  referenceId: string
  type: NameDto
}

export enum BonusBaseType {
  Restricted = 10,
  Tradeable = 20,
  DepositAndReserve = 30,
  Deposit = 40,
}

export interface BonusType {
  id: string
  name: string
  baseType: NameDto<BonusBaseType>
  amountType: NameDto
  bonusAmount: number
  lotsRequiredType: NameDto
  lotsRequired: number
  absoluteExpiryDate: null | string
  relativeExpiryInDays: number
}

export enum BonusTransactionStatus {
  ACTIVE = 10,
  CLOSED = 20,
}

export const isBonusTransactionStatusActive = (status: BonusTransactionStatus | number): boolean =>
  BonusTransactionStatus.ACTIVE === status

export const isBonusTransactionStatusClosed = (status: BonusTransactionStatus | number): boolean =>
  BonusTransactionStatus.CLOSED === status
